import gql from 'graphql-tag';

// Lightweight count of an org's own draft campaign orders (children's drafts
// excluded) — used by DraftPreviewHint on the campaigns page.
const COUNT_DRAFT_CAMPAIGN_ORDERS = gql`
  query draftCampaignOrdersCount($where: CampaignOrderWhereInput!) {
    campaignOrdersConnection(where: $where, first: 1) {
      aggregate {
        count
      }
    }
  }
`;

export default COUNT_DRAFT_CAMPAIGN_ORDERS;
